import { defineStore } from 'pinia';

import actions from './actions';
function initState() {
    return {
        list: []
    };
}

export default (storeName) => defineStore(storeName, {
    
    state: initState,
    
    actions
});
